import { useCallback } from 'react';
import type { MultiLang } from '../config';
import Functions from '../functions';
import ItemUtil, { type SearchCallbackFunc, type SortCondition } from './lib/ItemUtil';
import XoonipsListItem from './lib/XoonipsListItem';

interface Props {
    lang: MultiLang;
    type: string;
    keyword: string;
}

const XoonipsSearchByKeyword = (props: Props) => {
    const { lang, type, keyword } = props;

    const searchFunc = useCallback(
        (condition: SortCondition, func: SearchCallbackFunc) => {
            if (keyword === '') {
                func({ total: 0, data: [] });
            } else {
                ItemUtil.getListByKeyword(type, keyword, condition, func);
            }
        },
        [type, keyword]
    );

    return (
        <div className="list">
            <h3>{Functions.mlang('[en]Listing item[/en][ja]アイテム一覧[/ja]', lang)}</h3>
            <p>
                {Functions.mlang('[en]Search Keyword[/en][ja]検索キーワード[/ja]', lang)} : {keyword}
            </p>
            <XoonipsListItem lang={lang} url={ItemUtil.getSearchByKeywordUrl(type, keyword)} search={searchFunc} />
        </div>
    );
};

export default XoonipsSearchByKeyword;
